export class CsrDetalhePj {
  id: number;
  razao: string;
  cnpj: string;
  regime: string;
  cargo: string;
  cei: string;
  telcom: string;
  estado: string;
  cidade: string;
}
